<template>

    <div class="modal fade" id="searchContactModal" tabindex="-1" role="dialog" v-if="dataLoaded">
        <div class="modal-dialog modal-lg modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"><i class="mdi mdi-close"></i></span></button>
                    <h4 class="modal-title" v-text="lang.get('contacts.fg.header')"></h4>
                </div>
                <div class="modal-body text-center" v-if="getGrids['crm']">
                    <server-table
                        :data-columns="JSON.stringify(getGrids.crm.columns)"
                        :data-url="getGrids.crm.uri"
                        :preference-url="getGrids.crm.preferenceurl"
                        :doubleClickCb="dbclckCb"
                    ></server-table>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import Hub from '../../../Hub';
import Lang from '../../../Lang';
import ServerTable from '../../../Libraries/ServerTable/DefaultServerTable';

export default {

    components: {
        ServerTable,
    },

    computed: {
        ...mapGetters([
            'dataLoaded',
            'getGrids',
        ])
    },

    data() {
        return {
            lang:Lang,
        }
    },

    destroyed() {
        Hub.$off('close-contact-selector', this.closeSelector);
        Hub.$off('open-contact-selector', this.openSelector);
    },

    methods: {

        ...mapActions([
            'parseData',
        ]),

        closeSelector() {
            // Hide the modal
            $('#searchContactModal').modal('hide');
        },

        dbclckCb(e) {
            this.onSelected(e);
        },

        openSelector() {
            $('#searchContactModal').modal('show').on("shown.bs.modal");
        },

    },

    mounted() {
        if (!this.dataLoaded) {
            this.parseData();
        }

        this.$nextTick(function () {
            Hub.$on('close-contact-selector', this.closeSelector);
            Hub.$on('open-contact-selector', this.openSelector);
        }.bind(this));
    },

    name: "CrmSelector",

    props: {
        onSelected: Function
    },
}

</script>
